module.exports = __webpack_public_path__ + "static/media/takenote.ff8aa92f.png";